/*
Item: View for administators to
      - initiate creating new users
      - selecting a user to be edited
      - deleting users
Name: UserAdmin
Format: Frontend component, partial screen
*/

import React, { Component } from 'react';
import { Panel } from 'primereact/components/panel/Panel';
import { Button } from 'primereact/button';
import { Link } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { Messages } from 'primereact/messages';
import { InputText } from 'primereact/inputtext';
import { OverlayPanel } from 'primereact/overlaypanel';
import { DataTable } from 'primereact/components/datatable/DataTable';
import { Column } from 'primereact/components/column/Column';
import PropTypes from 'prop-types';
import { DropdownLabeled } from '../components/DropdownLabeled';
import MessageService from '../service/MessageService';
import {
  RoleMap, hasPermission, actions, returnUserRights,
} from '../utils/roleUtils';

const info = [
  {
    character: '*',
    description: 'Entspricht einer beliebigen Anzahl von Zeichen. Sie können das Sternchen (*) überall in einer Zeichenkette verwenden.',
    example: 'M*er findet Müller, Miller, Maler und Meister, aber nicht Motor oder Meyr',
  },
  {
    character: '?',
    description: 'Entspricht einem einzelnen Zeichen an einer bestimmten Stelle.',
    example: 'B?ll findet Ball, Bell und Bill',
  },
];
const rowsPerPage = 10;
const iconStyle = {
  color: 'grey',
};
const selectionList = [
  { name: 'Nachname', value: 'Nachname' },
  { name: 'Vorname', value: 'Vorname' },
  { name: 'E-Mail', value: 'Email' },
];

export default class UserAdmin extends Component {
  constructor(props) {
    super(props);

    this.messageService = new MessageService();
    this.state = {
      // state for search bar
      searchCriterion: { name: 'Nachname', value: 'Nachname' },
      searchText: '',
      // state for sorting
      sortCriterion: 'Nachname',
      sortDirection: 'ASC',
      sortingSelection: {
        Kennung: '',
        Nachname: 'ASC',
        Vorname: '',
        Email: '',
        LetzteAnmeldung: '',
      },
      // all users Data to show the table
      userData: null,
      // state variables for the delete dialog
      deleteDialogVisible: false,
      selectedUser: '',
      // paging
      rows: 10,
      first: 0,
      last: 0,
      totalRecords: 0,
    };

    this.showMessage = this.showMessage.bind(this);
    this.loadUserList = this.loadUserList.bind(this);
    this.hideDeleteDialog = this.hideDeleteDialog.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.handleDeleteDialogYes = this.handleDeleteDialogYes.bind(this);
    this.handleDeleteDialogNo = this.handleDeleteDialogNo.bind(this);
    this.openEditPage = this.openEditPage.bind(this);
    this.openDeleteDialog = this.openDeleteDialog.bind(this);
  }

  async onPage(event) {
    this.setState({ loading: true });
    const { first, page, rows, pageCount } = event;
    const result = '';
    const direction = 'TOP';
    const entries = null;
    const maxRowsPerPage = rows;
    const scrolling = false;
    const searchText = result;
    const sortDirection = 'ASC';
    let validPages;
    let potentialSelectionEntrySize;
    let type;
    let objtype;
    let object;
    let name;
    let sortCriterion;
    type = 'user';
    objtype = 'USER';
    object = 23;
    name = 'Nachname';
    sortCriterion = 'Nachname';
    const obj = {
      exactSearch: true,
      readingDirection: direction,
      entries,
      maxRowsPerPage,
      scrolling,
      sortCriterion,
      sortDirection,
      searchCriterion: name,
      searchText,
      objtype,
      object,
      page: page + 1,
      type,
    };
    let pageData;
    pageData = await this.messageService.postPageDirectory(obj);
    const userData = pageData.entrys;
    const last = first + rows;
    // validPages = pageData.viewSpecification.validPages;
    const totalRecords = pageData.viewSpecification.potentialSelectionEntrySize;
    this.setState({
      loading: false,
      userData,
      rows,
      first,
      last,
      totalRecords,
      pageCount,
      page,
    })
  }

  // onLoad read current data
  componentDidMount = () => {
    // const userRights = returnUserRights();
    // this.loadUserList(null, 'TOP', null, rowsPerPage);
    this.onPage({
      first: 0, rows: 10, page: 0, pageCount: 1,
    });
  }

  async handleDeleteDialogYes() {
    const {
      first, rows, page, pageCount,
    } = this.state;
    this.setState({ deleteDialogVisible: false });
    const { selectedUser } = this.state;
    const textMessage = await this.messageService.postUserDelete(selectedUser);
    this.showMessage(textMessage[0], textMessage[1]);
    this.onPage({
      first, rows, page, pageCount,
    });
  }

  handleDeleteDialogNo() {
    this.setState({ deleteDialogVisible: false, selectedUser: '' });
  }

  handleKeyDown(event) {
    if (event.keyCode === 13) {
      return this.loadUserList(null, 'TOP', null, rowsPerPage);
    }
    return Promise.resolve();
  }

  onSelectChange = (e) => {
    this.setState({ searchCriterion: e.value });
  }

  showUserList(entryList) {
    const userRights = returnUserRights();
    const cannotDelete = !hasPermission(userRights, actions.UserDelete);
    const cannotEdit = !hasPermission(userRights, actions.UserEditInfo);
    if (entryList) {
      return (
        <tbody>
          {entryList.map((s) => (
            <tr key={s.name}>
              <td>
                <Button
                  disabled={cannotDelete}
                  icon="pi-md-delete-forever"
                  title="löschen"
                  id="delete"
                  className="p-button-danger"
                  onClick={() => this.openDeleteDialog(s)}
                />
                <Button
                  disabled={cannotEdit}
                  icon="pi-md-edit"
                  title="bearbeiten"
                  id="edit"
                  className="p-button-info"
                  onClick={() => this.openEditPage(s)}
                />
              </td>
              <td>{s.name}</td>
              <td>
                {s.validTo ? (
                  <i className="pi-md-lock" style={iconStyle} />
                ) : (
                    ''
                  )}
              </td>
              <td>{s.contact.lastName}</td>
              <td>{s.contact.firstName}</td>
              <td>
                <a href={`mailto:${s.contact.email}`}>{s.contact.email}</a>
              </td>
              <td>{RoleMap[s.role]}</td>
              <td>{s.lastLogin ? s.lastLogin.split(' ')[0] : '-'}</td>
            </tr>
          ))}
        </tbody>
      );
    }
    return <tbody />;
  }

  makeHeaderCell(critName, text) {
    let criterionName = critName;
    const { sortingSelection, sortCriterion } = this.state;
    const lookup = sortingSelection[criterionName];
    criterionName = criterionName === 'LetzteAnmeldung' ? 'Letzte Anmeldung' : criterionName;
    let retColor;
    let retClass;
    if (criterionName !== sortCriterion) {
      retClass = 'p-sortable-column-icon pi pi-fw pi-sort';
      retColor = 'grey';
    } else {
      retColor = 'black';
      if (lookup === 'ASC') {
        retClass = 'p-sortable-column-icon pi pi-fw pi-sort-up';
      } else {
        retClass = 'p-sortable-column-icon pi pi-fw pi-sort-down';
      }
    }
    const sortingClass = retClass;
    return (
      <th style={{ cursor: 'pointer', color: retColor }} onClick={() => this.selectSorting(criterionName)}>
        {text}
        <span className={sortingClass} />
      </th>
    );
  }

  selectSorting(newSortCriterion, reset) {
    const { sortCriterion, sortDirection, sortingSelection } = this.state;
    let newSortDirection;
    if (!reset) {
      // set selection states:
      if (sortCriterion === newSortCriterion) {
        // search criterion remains unchanged -> change sort direction
        newSortDirection = sortDirection === 'DESC' ? 'ASC' : 'DESC';
      } else {
        // other search criterion -> change sort direction to ascending
        newSortDirection = 'DESC';
      }
    }
    sortingSelection[newSortCriterion] = newSortDirection;

    this.setState({ sortDirection: newSortDirection });
    this.setState({ sortCriterion: newSortCriterion });
    this.setState({ sortingSelection }, () => this.loadUserList(null, 'TOP', null, rowsPerPage));
  }

  openEditPage(adminData) {
    const { history } = this.props;
    history.push({
      pathname: '/useradmin/edituser',
      state: {
        entry: adminData,
      },
    });
  }

  makeDeleteDialogFooter() {
    return (
      <div>
        <Button
          label="Ja"
          id="yes"
          type="button"
          icon="pi pi-check"
          onClick={this.handleDeleteDialogYes}
        />
        <Button
          label="Nein"
          id="no"
          type="button"
          icon="pi pi-times"
          onClick={this.handleDeleteDialogNo}
          className="p-button-danger"
        />
      </div>
    );
  }

  hideDeleteDialog() {
    this.setState({ deleteDialogVisible: false, selectedUser: '' });
  }

  openDeleteDialog(user) {
    this.setState({ deleteDialogVisible: true, selectedUser: user });
  }

  // shows a Message at the top of the table
  showMessage(messageDetail, messageSeverity) {
    const msg = {
      life: 5000,
      severity: messageSeverity,
      detail: messageDetail,
    };
    this.messages.show(msg);
  }

  async loadUserList(returnMessage, direction, entries, maxRowsPerPage) {
    const {
      sortCriterion, sortDirection, searchCriterion, searchText,
    } = this.state;

    const userData = await this.messageService.postUserList(
      returnMessage,
      direction,
      entries,
      maxRowsPerPage,
      sortCriterion,
      sortDirection,
      searchCriterion.value,
      searchText,
    );
    if (userData.entrys) {
      if (userData.entrys.length > 0) {
        this.setState({
          userData: userData.entrys,
        });
      } else {
        this.showMessage('Es wurden keine weiteren Einträge gefunden.', 'info');
      }
    }
    if (userData[1] === 'error') {
      this.showMessage(userData[0], 'error');
      // reset search criteria
      this.setState({ searchText: '' });
      // start default search
    }
  }

  clearSearch() {
    this.setState({ searchText: '', searchCriterion: { name: 'Nachname', value: 'Nachname' } }, () => {
      this.loadUserList(null, 'TOP', null, rowsPerPage);
    });
  }

  actionTemplate(obj) {
    const userRights = returnUserRights();
    const cannotDelete = !hasPermission(userRights, actions.UserDelete);
    const cannotEdit = !hasPermission(userRights, actions.UserEditInfo);
    return (
      <>
        <Button
          disabled={cannotEdit}
          icon="pi-md-edit"
          title="bearbeiten"
          id="edit"
          className="p-button-info"
          onClick={() => this.openEditPage(obj)}
        />
        <Button
          disabled={cannotDelete}
          icon="pi-md-delete-forever"
          title="löschen"
          id="delete"
          className="p-button-danger"
          onClick={() => this.openDeleteDialog(obj)}
        />
      </>
    );
  }

  roleTemplate(obj) {
    return RoleMap[obj.role];
  }

  idTemplate(obj) {
    const { name, validTo } = obj;
    let ret;
    if (validTo) {
      ret = (<>{name}<i className="pi-md-lock" style={iconStyle} /></>);
    } else {
      ret = name;
    }
    return ret;
  }

  render() {
    const {
      rows, first, last, totalRecords,
      deleteDialogVisible, userData, searchCriterion, searchText,
      loading,
    } = this.state;
    const pageTemplate = `${first + 1} bis ${last} von ${totalRecords} Einträgen`;
    const userRights = returnUserRights();
    const cannotCreate = !hasPermission(userRights, actions.UserCreate);
    const paginatorLeft = (
      <Link to="/useradmin/newuser">
        <Button
          disabled={cannotCreate}
          icon="pi-md-plus"
          id="newuser"
          className="p-button-success"
          title="hinzufügen"
        />
      </Link>
    );
    const role = sessionStorage.getItem('role');
    if (role === 'INTERNAL_USER') {
      window.location.replace('./userdata');
      return null;
    }
    return (
      <div className="p-grid dashboard">
        <div className="p-col-12">
          <div className="card">
            <div className="p-col-12 p-lg-12 p-grid-nopad">
              <Messages
                ref={(el) => { (this.messages = el); }}
                style={{ marginBottom: '1em' }}
              />
            </div>
            <div className="p-grid">
              <DropdownLabeled
                label="Selektionskriterium"
                customClass="p-col-2"
                id="criterion"
                value={searchCriterion}
                options={selectionList}
                onChange={this.onSelectChange}
                optionLabel="name"
              />
              <div className="p-col-3">
                <span style={{
                  fontSize: '12px',
                }}
                >
                  &nbsp;
                </span>
                <span className="p-float-label">
                  <InputText id="search-input" type="text" size="33" value={searchText} onKeyDown={(e) => this.handleKeyDown(e)} onChange={(e) => this.setState({ searchText: e.target.value })} />
                  <label htmlFor="search-input">Suchtext</label>
                </span>
              </div>
              <OverlayPanel ref={(el) => { this.op = el; }} showCloseIcon dismissable>
                {/* eslint-disable-next-line react/no-unescaped-entities */}
                <p>Im Suchtext können Sie die Platzhalter '?' und '*'' benutzen:</p>
                <DataTable style={{ width: '48em' }} value={info}>
                  <Column style={{ width: '8em' }} field="character" header="Zeichen" />
                  <Column style={{ width: '20em' }} field="description" header="Beschreibung" />
                  <Column style={{ width: '20em' }} field="example" header="Beispiel" />
                </DataTable>
              </OverlayPanel>
              <div className="p-col-5">
                <Button
                  type="button"
                  id="info"
                  onClick={(e) => this.op.toggle(e)}
                  icon="pi pi-md-info-outline"
                />
                <Button
                  type="button"
                  id="search"
                  label="Suchen"
                  onClick={() => this.loadUserList(null, 'TOP', null, rowsPerPage)}
                />

                <Button
                  type="button"
                  id="clear"
                  className="p-button-primary"
                  label="Zurücksetzen"
                  onClick={() => this.clearSearch()}
                />
              </div>
              <div>
                <DataTable
                  selectionMode="single"
                  value={userData}
                  paginator
                  paginatorPosition="both"
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                  paginatorLeft={paginatorLeft}
                  rows={rows}
                  rowsPerPageOptions={[5, 10, 20, 30]}
                  currentPageReportTemplate={pageTemplate}
                  totalRecords={totalRecords || 0}
                  lazy
                  first={first}
                  onPage={(e) => this.onPage(e)}
                  loading={loading}
                  resizableColumns
                >
                  <Column field={this.idTemplate} header="ID" style={{ width: '3em' }} />
                  <Column field="contact.lastName" header="Nachname" style={{ width: '3em' }} />
                  <Column field="contact.firstName" header="Vorname" style={{ width: '4em' }} />
                  <Column field="contact.email" header="E-Mail" style={{ width: '4em' }} />
                  <Column field={this.roleTemplate} header="Rolle" style={{ width: '2em' }} />
                  <Column header="Aktionen" body={(obj) => this.actionTemplate(obj)} style={{ textAlign: 'center', width: '2em' }} />
                </DataTable>
              </div>
            </div>
          </div>
        </div>
        <Dialog
          header="Nutzer Löschen"
          visible={deleteDialogVisible}
          style={{ width: '40vw' }}
          footer={this.makeDeleteDialogFooter()}
          onHide={() => this.hideDeleteDialog()}
          modal
        >
          <p>Soll der Nutzer unwiderruflich gelöscht werden?</p>
        </Dialog>
      </div>
    );
  }
}

UserAdmin.propTypes = {
  history: PropTypes.instanceOf(Object),
};

UserAdmin.defaultProps = {
  history: null,
};
